/**
 * Handle active menu state for hash links and ensure proper scrolling to targets
 * Removes active state from current menu items and adds to hash link targets
 * Also handles scrolling to hash targets with retry logic for WP Rocket compatibility
 */
function initHashNavigation() {
  let scrollAttempts = 0;
  const maxScrollAttempts = 10;

  function smoothScrollToTarget(targetId, attempt = 0) {
    const target = document.getElementById(targetId);

    if (target) {
      // Calculate offset for fixed header if exists
      const header = document.querySelector("header");
      const offset = header ? header.offsetHeight + 20 : 20;

      const targetPosition =
        target.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });

      scrollAttempts = 0;
      return true;
    }

    // Retry logic for cases where content is still loading (WP Rocket, lazy loading, etc.)
    if (attempt < maxScrollAttempts) {
      setTimeout(() => {
        smoothScrollToTarget(targetId, attempt + 1);
      }, 100 + attempt * 50); // Increasing delay
    }

    return false;
  }

  function handleHashScroll(hash) {
    if (!hash) return;

    // Remove the # from hash
    const targetId = hash.substring(1);

    // Try immediate scroll first
    if (!smoothScrollToTarget(targetId)) {
      // If target not found, wait for page to load completely
      if (document.readyState !== "complete") {
        window.addEventListener(
          "load",
          () => {
            smoothScrollToTarget(targetId);
          },
          { once: true }
        );
      }
    }
  }

  function updateActiveMenuItem() {
    const hash = window.location.hash;
    const menuItems = document.querySelectorAll(
      "nav.primary-nav ul li, nav.primary-nav-mobile ul li"
    );

    if (hash) {
      // Only manipulate menu states when there's a hash
      // Remove current-menu-item class and data-hash-active attribute from all items
      menuItems.forEach((item) => {
        item.classList.remove("current-menu-item");
        item.removeAttribute("data-hash-active");
      });

      // Find menu item that links to this hash
      const hashLink = document.querySelector(
        `nav.primary-nav a[href*="${hash}"], nav.primary-nav-mobile a[href*="${hash}"]`
      );
      if (hashLink) {
        const menuItem = hashLink.closest("li");
        menuItem.classList.add("current-menu-item");
        menuItem.setAttribute("data-hash-active", "true");
      }

      // Handle scrolling to the target
      handleHashScroll(hash);
    } else {
      // No hash - only clean up hash-specific attributes, preserve WordPress menu states
      menuItems.forEach((item) => {
        item.removeAttribute("data-hash-active");
      });
    }
  }

  // Update on page load
  updateActiveMenuItem();

  // Update when hash changes
  window.addEventListener("hashchange", updateActiveMenuItem);

  // Update when clicking on hash links (ignore tabs)
  document.addEventListener("click", function (e) {
    const link = e.target.closest('a[href*="#"]');
    if (link && !link.closest("[data-tabs]")) {
      // Small delay to ensure hash has changed
      setTimeout(updateActiveMenuItem, 10);
    }
  });

  // Handle direct navigation to hash URLs - with delay for WP Rocket
  const initialHash = window.location.hash || window.initialHash;
  if (initialHash) {
    updateActiveMenuItem();

    // Additional delayed attempts for WP Rocket cached pages
    setTimeout(() => {
      handleHashScroll(initialHash);
    }, 250);

    setTimeout(() => {
      handleHashScroll(initialHash);
    }, 500);

    setTimeout(() => {
      handleHashScroll(initialHash);
    }, 1000);

    setTimeout(() => {
      handleHashScroll(initialHash);
    }, 2000);
  }

  // Listen for WP Rocket's specific events if available
  if (typeof window.RocketLazyLoadScripts !== "undefined") {
    document.addEventListener("rocket-lazy-loaded", () => {
      if (window.location.hash) {
        handleHashScroll(window.location.hash);
      }
    });
  }

  // Listen for images loaded event which might affect layout
  window.addEventListener("load", () => {
    if (window.location.hash) {
      setTimeout(() => {
        handleHashScroll(window.location.hash);
      }, 100);
    }
  });
}

export default initHashNavigation;
